module.exports = __webpack_public_path__ + "static/img/profile.26149ee1.jpg";